import Card from '../../../_common/components/CardDashboard/Card'
import CardHelp from '../../../_common/components/CardDashboard/CardHelp'
import Comunicados from '../../../comunicados/comunicados'
import { AppPage } from '../../../_common/components/app-page'
import { C } from '../../../_common/layout'
import { Link } from 'react-router-dom'
import { connect, useSelector } from "react-redux";
import { fetchAcademicSection } from '../../../_rx/academic-sections/actions'
import { h } from 'preact'
import { isMobileAgent } from '../../../_common/common'
import { t } from '../../../_i18n'
import { useDispatch } from 'react-redux'
import { useEffect, useState } from 'preact/hooks'
import { setHelpModeStep } from '../../../_rx/_general/actions'
import { HelperTooltip } from '../../../_common/components/HelperTooltip/HelperTooltip'

import './trial-dashboard-styles.scss'
import TrialBanner from "../../../trial-banner/trial-banner";
import SalesBanner from "../../../sales-banner/sales-banner";

function TrialDashboard({ user, studentMeta, academicSection, comunicadosStatus, helpModeStep, setHelpModeStep }) {
    /** Redux **/
    const dispatch = useDispatch()
    const isMobile = isMobileAgent()

    /** Variables **/
    const currentSemesterId = 63
    const totalSteps = 7
    const stepScrollPosition = {
        1: 'end',
        5: !isMobile && 'end',
        6: 'end',
        7: 'end',
    };

    const trialModalityAnnual = studentMeta.trial_academic_section_modality.toUpperCase() == 'ANNUAL';
    const demoBanners = [
        {
            modalTitle: trialModalityAnnual ? t('Matricúlate ahora del primer curso') : t('Matricúlate ahora del primer semestre'),
            discountTitle: trialModalityAnnual ? t('Matricúlate ahora del primer curso') : t('Matricúlate ahora del primer semestre'),
            discountSubtitle: t("Aprovecha el descuento si te matriculas ahora."),
            buttonLabel: "¡Matricúlate ahora!",
            style: {
                backgroundColor: "black",
                buttonWidth: 300,
                textMaxWidth: 520,
            },
            discountBadge: trialModalityAnnual ? t('5% dto.') : t('10% dto.'),
            discountBadge1: "-5€"
        }
    ];

    /** Lifecycle **/
    useEffect(() => {
        setHelpModeStep(0)
        dispatch(fetchAcademicSection(currentSemesterId))
    }, [])

    /** Methods **/
    const handleNotices = () => {
        const element = document.querySelector('.comunicados')
        element.scrollIntoView({ behavior: 'smooth' })
    }

    const scrollToStep = (step) => {
        const el = document.getElementById(`step-${step}`);
        if (!el) return;

        const blockPosition = stepScrollPosition[step] || 'start';

        el.scrollIntoView({
            behavior: 'smooth',
            block: blockPosition
        });
    };

    const handleOnNext = () => {
        const next = helpModeStep + 1;
        setHelpModeStep(next);
        scrollToStep(next);
    };

    const handleOnPrev = () => {
        const prev = helpModeStep - 1;
        setHelpModeStep(prev);
        scrollToStep(prev);
    };

    const handleOnClose = () => setHelpModeStep(0)

    /** Render **/
    return (academicSection) &&
        <AppPage name='dashboard'>
            <div className={helpModeStep ? 'overlay z-1': ''} onClick={() => helpModeStep && setHelpModeStep(0)} />
            <div className={`dashboard-container ${!isMobile ? 'max-width-1380' : ''}`}>
                <C className={`dashboard ${!isMobile ? 'max-width-980' : ''}`}>
                    {/** User Name **/}
                    <h1 className='hero m-x2-bottom'>¡{t('Hola,')} {user.name.trim()}!</h1>
                    {/** Notifications **/}
                    {comunicadosStatus?.unread > 0 && (
                        <HelperTooltip
                            onNext={handleOnNext}
                            onPrev={handleOnPrev}
                            step={helpModeStep}
                            subtitle='Aquí verás los avisos que necesitan tu atención inmediata.'
                            title='¡No dejes nada pendiente!'
                            totalSteps={totalSteps}
                            visible={helpModeStep == 1}
                        >
                            <span className={helpModeStep == 1 && 'z-100 background-white'} id='step-1'>
                                👋 {t('Tienes {num} comunicado{plural} sin leer')
                                    .replace('{num}', comunicadosStatus.unread)
                                    .replace('{plural}', comunicadosStatus.unread === 1 ? '' : 's')}
                                . <span
                                    onClick={handleNotices}
                                    className='font-color-149BAB t-underline cursor-pointer'
                                >
                                    {t(comunicadosStatus.unread === 1 ? 'Leer comunicado' : 'Leer comunicados')}
                                </span>
                            </span>
                        </HelperTooltip>
                    )}
                    {studentMeta.has_pending_exam_inscriptions &&
                        <div className='font-18 m-bottom'>
                            <span>👉 {t('Tienes inscripciones a exámenes pendientes')}. <Link className='font-color-149BAB' to='/examenes'>{t('Realiza las inscripciones')}</Link>
                            </span>
                        </div>
                    }
                    {demoBanners?.map((banner, i) =>
                      <div class='m-top-x2'>
                          <TrialBanner
                            key={i}
                            {...banner}
                            studentMeta={studentMeta}
                            user={user}
                          />
                      </div>
                    )}
                    {/** Dashboard Cards **/}
                    <div className='d-flex m-top dashboard__panel'>
                        <HelperTooltip
                            card
                            onClose={handleOnClose}
                            onNext={handleOnNext}
                            onPrev={handleOnPrev}
                            step={helpModeStep}
                            subtitle='Entra a las aulas virtuales y accede a todo el contenido de las asignaturas que estás cursando.'
                            title='Tu espacio de estudio diario'
                            totalSteps={totalSteps}
                            visible={helpModeStep === 2}
                        >
                            <Card
                                id='step-2'
                                className={`max-width-initial ${helpModeStep === 2 && 'z-100'}`}
                                content={t('Accede a tus aulas virtuales y recursos de estudio.')}
                                externalInWindow
                                fullWidth
                                title={t('Campus')}
                                to={studentMeta.online_campus_url}
                            />
                        </HelperTooltip>
                        <HelperTooltip
                            card
                            onNext={handleOnNext}
                            onPrev={handleOnPrev}
                            step={helpModeStep}
                            subtitle='Consulta el detalle de tus notas y resultados.'
                            title='Sigue tu evolución académica'
                            totalSteps={totalSteps}
                            visible={helpModeStep === 3}
                        >
                            <Card
                                id='step-3'
                                className={`max-width-initial ${helpModeStep === 3 && 'z-100'}`}
                                content={t('Consulta tu expediente académico y el estado de tus asignaturas.')}
                                fullWidth
                                title={t('Expediente académico')} to='/expediente'
                            />

                        </HelperTooltip>
                        <HelperTooltip
                            card
                            onNext={handleOnNext}
                            onPrev={handleOnPrev}
                            step={helpModeStep}
                            subtitle='Solicita certificados y realiza tus trámites administrativos de forma rápida.'
                            title='Tu gestión administrativa'
                            totalSteps={totalSteps}
                            visible={helpModeStep === 4}
                        >
                            <Card
                                title={t('Secretaría')}
                                id='step-4'
                                className={`max-width-initial ${helpModeStep === 4 && 'z-100'}`}
                                content={t('Solicita certificados o realiza otras gestiones administrativas con el departamento de Secretaría.')}
                                disabled
                                fullWidth
                            />
                        </HelperTooltip>
                        <HelperTooltip
                            card
                            onNext={handleOnNext}
                            onPrev={handleOnPrev}
                            position={!isMobile && 'top'}
                            step={helpModeStep}
                            subtitle='Consulta tutoriales paso a paso e información académica clave.'
                            title='Tu centro de soporte'
                            totalSteps={totalSteps}
                            visible={helpModeStep === 5}
                        >
                            <Card
                                id='step-5'
                                title={t('Área Onliner')}
                                className={`max-width-initial ${helpModeStep === 5 && 'z-100'}`}
                                content={t('Consulta información académica y los tutoriales de ayuda.')}
                                disabled
                                fullWidth
                            />
                        </HelperTooltip>
                        <HelperTooltip
                            onNext={handleOnNext}
                            onPrev={handleOnPrev}
                            position='top'
                            step={helpModeStep}
                            subtitle='Reserva una cita con nuestro equipo de Atención al Alumno y te llamamos.'
                            title='Tu soporte personalizado'
                            totalSteps={totalSteps}
                            visible={helpModeStep === 6}
                        >
                            <CardHelp
                                id='step-6'
                                fullWidth
                                className={`${helpModeStep === 6 && 'z-100'}`}
                            />
                        </HelperTooltip>
                    </div>

                    {/** Comunicados **/}
                    <HelperTooltip
                        onClose={handleOnClose}
                        onNext={handleOnNext}
                        onPrev={handleOnPrev}
                        position='top'
                        step={helpModeStep}
                        subtitle='Aquí encontrarás toda la información importante para tu día a día en iLERNA.'
                        title='¡Que no se te pase nada!'
                        totalSteps={totalSteps}
                        visible={helpModeStep === 7}
                    >
                        <Comunicados
                            id='step-7'
                            isolateComponent
                            className={`${isMobile ? 'm-top-x2' : 'm-top'} ${helpModeStep === 7 && 'z-100 background-white'}`}
                        />
                    </HelperTooltip>

                </C>
            </div>
        </AppPage>
}

/** Container **/
const TrialDashboardContainer = connect(
    ({ auth, status, academicSection, comunicados_status, general }) => ({
        user: auth.loggedUser,
        studentMeta: status.student_meta,
        academicSection,
        comunicadosStatus: comunicados_status,
        helpModeStep: general.helpModeStep
    }),
    { setHelpModeStep }
)(TrialDashboard)

/** Export **/
export default TrialDashboardContainer
